import { FC, ReactElement, useEffect } from 'react';
import { IRouteComponentProps } from 'umi';
import { Spin } from 'antd';

const DownloadPage: FC<IRouteComponentProps> = (): ReactElement => {
  const userAgentInfo = window.navigator.userAgent;

  const isIOS = () => {
    return (
      userAgentInfo.indexOf('iPhone') > 0 || userAgentInfo.indexOf('iPad') > 0
    );
  };
  //
  useEffect(() => {
    isIOS()
      ? window.location.replace(
          'https://apps.apple.com/zm/app/ignite-by-igloo/id1586274956',
        )
      : window.location.replace(
          'https://play.google.com/store/apps/details?id=com.agencyplatform',
        );
  }, []);
  return (
    <div>
      <Spin
        spinning={true}
        style={{
          width: '100%',
          height: '400px',
          margin: '0 auto',
          marginTop: ' 300px',
        }}
      ></Spin>
    </div>
  );
};

export default DownloadPage;
